import React from "react";
import { CATEGORIES, SUBCATEGORIES } from '../../constants/categories';
import CheckboxGroup from './CheckboxGroup';

function CategorySubcategoryPicker({ categories, subcategories, onCategoriesChange, onSubcategoriesChange, otherCategory, onOtherCategoryChange, otherSubcategories, onOtherSubcategoryChange }) {
  const handleCatChange = newCats => {
    const addedCats   = newCats.filter(c => !categories.includes(c));
    const removedCats = categories.filter(c => !newCats.includes(c));
    const kept    = subcategories.filter(s => !removedCats.some(c => (SUBCATEGORIES[c]||[]).includes(s)));
    // If all categories are now selected, auto-select all subcategories
    const allCatsSelected = newCats.length === CATEGORIES.length;
    let merged = kept;
    if (allCatsSelected) {
      const allSubs = newCats.flatMap(c => SUBCATEGORIES[c] || []);
      merged = [...new Set([...kept, ...allSubs])];
    } else {
      // Auto-select subcategories for newly added categories
      const newSubs = addedCats.flatMap(c => SUBCATEGORIES[c] || []);
      merged = [...new Set([...kept, ...newSubs])];
    }
    onCategoriesChange(newCats);
    onSubcategoriesChange(merged);
    // Show the Other text input for any newly added category whose subcats include Other
    if (onOtherSubcategoryChange) {
      addedCats.forEach(cat => {
        if ((SUBCATEGORIES[cat] || []).includes('Other'))
          onOtherSubcategoryChange(cat, '');
      });
      removedCats.forEach(cat => {
        if ((SUBCATEGORIES[cat] || []).includes('Other'))
          onOtherSubcategoryChange(cat, null);
      });
    }
  };
  const toggleSubAll = (cat, catSubs) => {
    const allOn  = catSubs.every(s => subcategories.includes(s));
    const others = subcategories.filter(s => !catSubs.includes(s));
    onSubcategoriesChange(allOn ? others : [...others, ...catSubs]);
    // Show/hide the Other text input when Select All toggles Other in or out
    if (catSubs.includes('Other') && onOtherSubcategoryChange)
      onOtherSubcategoryChange(cat, allOn ? null : '');
  };
  const toggleSub = (sub, cat) => {
    const isRemoving = subcategories.includes(sub);
    onSubcategoriesChange(isRemoving ? subcategories.filter(s => s !== sub) : [...subcategories, sub]);
    if (sub === 'Other') {
      if (!isRemoving) {
        // Mark this cat's Other as active (empty string = checked, no text yet)
        onOtherSubcategoryChange && onOtherSubcategoryChange(cat, '');
      } else {
        // Remove this cat's Other entry
        onOtherSubcategoryChange && onOtherSubcategoryChange(cat, null);
      }
    }
  };
  return (
    <>
      <CheckboxGroup label="Your Categories *" options={CATEGORIES} selected={categories.filter(c => CATEGORIES.includes(c))} onChange={handleCatChange} otherValue={otherCategory||''} onOtherChange={v=>onOtherCategoryChange && onOtherCategoryChange(v)} />
      {categories.filter(c => CATEGORIES.includes(c)).length > 0 && (
        <div className="subcat-block">
          <div style={{ fontSize:12, fontWeight:700, color:'#7a6a5a', textTransform:'uppercase', letterSpacing:1, marginBottom:16 }}>
            Subcategories — select all that apply
          </div>
          {categories.filter(c => CATEGORIES.includes(c)).map(cat => {
            const catSubs = SUBCATEGORIES[cat] || [];
            const allOn   = catSubs.length > 0 && catSubs.every(s => subcategories.includes(s));
            return (
              <div key={cat} className="subcat-cat">
                <div className="subcat-cat-header">
                  <span className="subcat-cat-name">{cat}</span>
                  <button className={`btn-select-all${allOn ? ' all-on' : ''}`} onClick={() => toggleSubAll(cat, catSubs)}>
                    {allOn ? '\u2713 All' : 'Select All'}
                  </button>
                </div>
                <div className="checkbox-grid">
                  {catSubs.map(sub => (
                    <label key={sub} className={`checkbox-item${subcategories.includes(sub) ? ' checked' : ''}`}>
                      <input type="checkbox" checked={subcategories.includes(sub)} onChange={() => toggleSub(sub, cat)} />
                      {sub}
                    </label>
                  ))}
                </div>
                {catSubs.includes('Other') && subcategories.includes('Other') && otherSubcategories && otherSubcategories[cat] !== undefined && (
                  <div style={{marginTop:6,paddingTop:6,borderTop:'1px solid #e8ddd0'}}>
                    <input
                      autoFocus
                      placeholder={`Describe your "${cat}" subcategory...`}
                      value={(otherSubcategories&&otherSubcategories[cat])||''}
                      onChange={e=>onOtherSubcategoryChange && onOtherSubcategoryChange(cat, e.target.value)}
                      style={{width:'100%',border:'1.5px solid #c8a84b',borderRadius:8,padding:'8px 12px',
                        fontSize:13,fontFamily:'DM Sans,sans-serif',boxSizing:'border-box',outline:'none',background:'#fdf9f5'}}
                    />
                  </div>
                )}
              </div>
            );
          })}
          {subcategories.filter(s => categories.filter(c => CATEGORIES.includes(c)).some(c => (SUBCATEGORIES[c]||[]).includes(s))).length > 0 && (
            <div className="selected-tags">
              {subcategories.filter(s => categories.filter(c => CATEGORIES.includes(c)).some(c => (SUBCATEGORIES[c]||[]).includes(s))).map(s => <span key={s} className="sel-tag">{s}</span>)}
            </div>
          )}
        </div>
      )}
    </>
  );
}

export default CategorySubcategoryPicker;
